import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

type InputsProps = {
  name: string;
  label: string;
  unit: string;
  type?: string;
}

const Inputs: FC<InputsProps> = ({ name, label, unit, type = 'number' }) => {
  const {
    register,
    formState: { isSubmitting, errors },
  } = useFormContext();

  const errorMessage = errors[name]?.message as string

  return (
    <React.Fragment>
      <div className='box marginTop'>
        <div className='flex-1'>{label}</div>
        <div className='flex-2 data'>
          <div className='flex'>
            <input {...register(name)} className='flex-1 input' disabled={isSubmitting} type={type} />
            <div>{unit}</div>
          </div>
        </div>
      </div>
      <div className='box'>
        <div className='flex-1' />
        {errorMessage && <div className='flex-2 error'>* {errorMessage}</div>}
      </div>
    </React.Fragment>
  );
};

export default Inputs;
